// import ConstructionIcon from '@mui/icons-material/Construction'
// import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'
// import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
// import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined'
// import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined'
// import ListAltIcon from '@mui/icons-material/ListAlt'
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
// import QueryStatsIcon from '@mui/icons-material/QueryStats'
// import HistoryIcon from '@mui/icons-material/History'
// import { Avatar, Box, Button, Drawer, Icon, Stack, Typography, IconButton } from '@mui/material'
// import { useTheme, Theme } from '@mui/material/styles'
// import useMediaQuery from '@mui/material/useMediaQuery'
// import PropTypes from 'prop-types'
// import type { FC, ReactNode } from 'react'
// import React, { useEffect, useState } from 'react'
// import { Img } from 'react-image'
// import { Link as RouterLink, useLocation } from 'react-router-dom'
// import PATHS from 'src/common/constants/paths'
// import useAuth from 'src/hooks/useAuth'
// import DefaultAvatar from 'src/icons/DefaultAvatar'
// import NavSection from '../../general/NavSection'
// import Scrollbar from '../../general/Scrollbar'
// import CloseIcon from '@mui/icons-material/Close'
// import logo from 'src/icons/logo-dark.svg'
// import { FaArrowRightToBracket } from 'react-icons/fa6'
// import { AiOutlineClose } from 'react-icons/ai'
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
// import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
// import { Link } from 'react-router-dom'
// import { RiArrowRightDoubleFill } from 'react-icons/ri'
// import DashboardNavbar from 'src/components/dashboard/layout/DashboardNavbar'

// interface DashboardSidebarProps {
//     onMobileClose: () => void
//     openMobile: boolean
//     collapsed: boolean
//     isMobile: boolean
//     isSidebarMobileOpen: boolean
//     setIsSidebarMobileOpen: React.Dispatch<React.SetStateAction<boolean>>
//     setCollapsed: React.Dispatch<React.SetStateAction<boolean>>
// }

// interface NavItem {
//     icon: ReactNode
//     title: string
//     path: string
//     disabled?: boolean
//     hover?: string
//     tooltip?: string
//     accessCondition?: boolean
//     children?: { title: string; hover?: string; path: string }[]
// }

// interface dashboardSections {
//     title: string
//     items: NavItem[]
// }

// const activeButton = (path: string, include: string[]) => {
//     if (
//         include.filter((elem) => {
//             return path.includes(elem)
//         }).length > 0
//     ) {
//         return { borderBottom: '2px solid #E4933D', backgroundImage: 'linear-gradient(to bottom, #091E50, #132E69)' }
//     } else return { bgcolor: 'transparent', color: 'primary' }
// }

// const buttonNavBarStyle = {
//     py: '1.21rem',
//     width: { lg: '200px' },
//     '&:hover': { backgroundImage: 'linear-gradient(to bottom, #091E50, #132E69)' },
// }

// const defaultSections: dashboardSections[] = [
//     {
//         title: '',
//         items: [
//             {
//                 icon: (
//                     <Icon sx={{ display: 'flex', alignItems: 'center' }}>
//                         <img src="/static/icons/discord_white.svg" alt="Discord" />
//                     </Icon>
//                 ),
//                 title: 'Community',
//                 path: `${PATHS.DASHBOARD.COMMUNITY}`,
//             },
//             {
//                 icon: <NotificationsNoneIcon />,
//                 title: 'Alerts',
//                 path: `${PATHS.DASHBOARD.ALERTS}`,
//             },
//             {
//                 icon: <ConstructionIcon />,
//                 title: 'Extension',
//                 path: `${PATHS.DASHBOARD.EXTENSION}`,
//             },
//             {
//                 icon: <HelpOutlineIcon />,
//                 title: 'Support',
//                 path: `${PATHS.DASHBOARD.SUPPORT}`,
//             },
//         ],
//     },
// ]

// const sectionsTopSelling: dashboardSections[] = [
//     {
//         title: '',
//         items: [
//             {
//                 icon: (
//                     <Stack width="100%" height="100%" alignItems="center" justifyContent="center">
//                         <Img
//                             style={{ width: '60%', height: '60%', alignSelf: 'center' }}
//                             src="/static/logo.svg"
//                             alt="Logo"
//                         />
//                     </Stack>
//                 ),
//                 title: 'Home',
//                 path: `${PATHS.DASHBOARD.UPCOMING.ROOT}`,
//             },
//         ],
//     },
// ]

// const sectionsAnalytics = (user: any): dashboardSections[] => [
//     {
//         title: '',
//         items: [
//             {
//                 icon: <EventAvailableOutlinedIcon />,
//                 title: 'My Primary Favorites',
//                 path: `${PATHS.DASHBOARD.PRIMARY_FAVORITES}`,
//                 hover: 'Save and track your favorite events on the primary market. You can also perform and view actions such as drop checkers and low inventory alerts for your favorites.',
//                 tooltip: 'My Primary Favorites',
//             },
//             {
//                 icon: <EventOutlinedIcon />,
//                 title: 'My Secondary Favorites',
//                 path: `${PATHS.DASHBOARD.SECONDARY_FAVORITES}`,
//                 hover: 'Save and track your favorite events on the secondary market. You can also perform and view actions such as price drop alerts for your favorites.',
//                 tooltip: 'My Secondary Favorites',
//             },
//             {
//                 icon: <QueryStatsIcon />,
//                 title: 'Primary Top Movers',
//                 hover: 'View top moving events by the most tickets sold or highest percentage change on the primary market.',
//                 path: `${PATHS.DASHBOARD.PRIMARY_TOP_MOVERS}`,
//                 tooltip: 'Primary Top Movers',
//                 accessCondition: user.payment_plans?.[0]?.hasAccessToTopMovers,
//             },
//             {
//                 icon: <HistoryIcon />,
//                 title: 'Custom Requests History',
//                 path: `${PATHS.DASHBOARD.CUSTOM_REQUESTS_HISTORY}`,
//                 hover: 'View the status and details of your data refresh requests for StubHub events.',
//                 tooltip: 'Custom Requests History',
//             },
//         ],
//     },
// ]

// const sectionsAdmin: dashboardSections[] = [
//     {
//         title: '',
//         items: [
//             {
//                 icon: <ListAltIcon />,
//                 title: 'General',
//                 path: `${PATHS.DASHBOARD.ADMIN.ROOT}`,
//                 children: [
//                     {
//                         title: 'Subscription Management',
//                         path: `${PATHS.DASHBOARD.ADMIN.SUBSCRIPTION_MANAGEMENT}`,
//                         hover: 'Manage users subscription',
//                     },
//                     {
//                         title: 'Tier Management',
//                         path: `${PATHS.DASHBOARD.ADMIN.TIER_MANAGEMENT}`,
//                         hover: 'Manage tiers',
//                     },
//                     { title: 'Venue Match', path: `${PATHS.DASHBOARD.ADMIN.VENUE_MATCH}`, hover: 'Venue matching' },
//                     { title: 'Event Match', path: `${PATHS.DASHBOARD.ADMIN.EVENT_MATCH}`, hover: 'Event matching' },
//                     {
//                         title: 'Venue Mismatch',
//                         path: `${PATHS.DASHBOARD.ADMIN.VENUE_MISMATCH}`,
//                         hover: 'Venue mismatching',
//                     },
//                     { title: 'Seat Groups', path: `${PATHS.DASHBOARD.ADMIN.SEAT_GROUPS}`, hover: 'Seat groups' },
//                     {
//                         title: 'Add Venue Urls',
//                         path: `${PATHS.DASHBOARD.ADMIN.VENUE_URLS}`,
//                         hover: 'Add/remove venue urls',
//                     },
//                     {
//                         title: 'Add Blacklist Words',
//                         path: `${PATHS.DASHBOARD.ADMIN.BLACKLIST}`,
//                         hover: 'Add/remove black list words',
//                     },
//                     {
//                         title: 'Scrape Venue',
//                         path: `${PATHS.DASHBOARD.ADMIN.SCRAPE_VENUE}`,
//                         hover: 'Scrape a venue using venue id',
//                     },
//                     {
//                         title: 'Hot Sections',
//                         path: `${PATHS.DASHBOARD.ADMIN.HOT_SECTIONS}`,
//                         hover: 'Find out hot sections',
//                     },
//                     { title: 'SH Daily', path: `${PATHS.DASHBOARD.ADMIN.SH_DAILY}`, hover: 'SH Daily' },
//                     { title: 'TM Daily', path: `${PATHS.DASHBOARD.ADMIN.TM_DAILY}`, hover: 'TM Daily' },
//                     {
//                         title: 'Stubhub Helper',
//                         path: `${PATHS.DASHBOARD.ADMIN.STUBHUB_HELPER}`,
//                         hover: 'Stubhub Helper',
//                     },
//                     {
//                         title: 'Client API Admin',
//                         path: `${PATHS.DASHBOARD.ADMIN.CLIENT_API_ADMIN}`,
//                         hover: 'Manage Client API Users and Settings',
//                     },
//                     {
//                         title: 'Rate Limit',
//                         path: `${PATHS.DASHBOARD.ADMIN.RATE_LIMIT}`,
//                         hover: 'Manage Rate Limit',
//                     },
//                 ],
//             },
//         ],
//     },
// ]

// const isAccordionActive = (parentPaths: string[], pathname: string) => {
//     return parentPaths.some((parentPath) => pathname === parentPath || pathname.startsWith(parentPath + '/'))
// }

// const DashboardSidebar: FC<DashboardSidebarProps> = (props) => {
//     const {
//         onMobileClose,
//         openMobile,
//         collapsed,
//         setIsSidebarMobileOpen,
//         setCollapsed,
//         isSidebarMobileOpen,
//         isMobile,
//     } = props
//     const { user } = useAuth()
//     const [sections, setSections] = useState<dashboardSections[]>(defaultSections)
//     const location = useLocation()

//     const [expandedAccordion, setExpandedAccordion] = useState<string | false>(false)
//     const [isExpended, setisExpended] = useState(false)

//     const sectionsUpcoming: dashboardSections[] = [
//         {
//             title: '',
//             items: [
//                 {
//                     icon: <ListAltIcon />,
//                     title: 'General',
//                     path: `${PATHS.DASHBOARD.ROOT}`,
//                     ...(!isMobile && {
//                         children: [
//                             { title: 'Watch List', path: `${PATHS.DASHBOARD.UPCOMING.WATCHLIST}` },
//                             { title: 'My Buying List', path: `${PATHS.DASHBOARD.UPCOMING.BUYING_LIST}` },
//                         ],
//                     }),
//                 },
//             ],
//         },
//     ]

//     const isTopSelling = location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`)
//     const handleToggle = () => {
//         setisExpended((prev) => !prev)
//     }

//     const isHeaderNavbarHidden = [PATHS.DASHBOARD.SECONDARY_TOP_SELLING, PATHS.DASHBOARD.HISTORICAL_DATA].some((path) =>
//         location.pathname.includes(path)
//     )

//     useEffect(() => {
//         if (location.pathname.includes(`${PATHS.DASHBOARD.UPCOMING.ROOT}`)) {
//             setSections([...sectionsUpcoming, ...defaultSections])
//         } else if (
//             [
//                 PATHS.DASHBOARD.EVENT_ANALYTICS,
//                 PATHS.DASHBOARD.SECONDARY_ANALYTICS.split(':')[0],
//                 PATHS.DASHBOARD.PRIMARY_ANALYTICS.split(':')[0],
//                 PATHS.DASHBOARD.PRIMARY_FAVORITES,
//                 PATHS.DASHBOARD.SECONDARY_FAVORITES,
//                 PATHS.DASHBOARD.USER,
//                 PATHS.DASHBOARD.METRIC.ROOT,
//                 PATHS.DASHBOARD.PRIMARY_TOP_MOVERS,
//             ].some((path) => location.pathname.includes(path))
//         ) {
//             const modifiedSections = sectionsAnalytics(user)?.map((section) => ({
//                 ...section,
//                 items: section.items?.map((item) => ({
//                     ...item,
//                     disabled: typeof item.accessCondition === 'boolean' ? !item.accessCondition : false,
//                 })),
//             }))
//             setSections([...modifiedSections, ...defaultSections])
//         } else if (location.pathname.includes(`${PATHS.DASHBOARD.ADMIN.ROOT}`)) {
//             setSections([...sectionsAdmin, ...defaultSections])
//         }
//         // else if (isHeaderNavbarHidden) {
//         //     setSections([...sectionsTopSelling])
//         // }
//         else {
//             setSections([...sectionsUpcoming, ...defaultSections])
//         }
//     }, [location.pathname, user, openMobile, onMobileClose])
//     const isEventAnalyticsPage =
//         window.location.pathname === '/dashboard/event_analytics' ||
//         window.location.pathname.includes('/dashboard/secondary-analytics/') ||
//         window.location.pathname.includes('/dashboard/primary-analytics/')
//     const content = (
//         <Box
//             sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 // maxHeight: '100vh',
//                 minHeight: location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`) ? '100vh' : '100vh',
//                 maxHeight: location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`) ? '100vh' : '94vh',
//                 // maxHeight: '100vh',
//                 overflow: 'auto',
//                 zIndex: 1300,
//                 justifyContent: 'space-between',
//                 background: '#061536',
//                 paddingBottom: '30px',
//                 width: isMobile ? '330px' : collapsed && !isMobile ? '80px' : '250px',
//                 transition: 'width 0.3s ease',
//                 position: 'fixed',
//                 borderTopRightRadius: location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`)
//                     ? '20px' // Apply border radius when on secondary-top-selling
//                     : '0px', // No border radius for other paths
//             }}
//         >
//             {isMobile && (
//                 <>
//                     <Box
//                         display={'flex'}
//                         justifyContent={'space-between'}
//                         padding={'20px'}
//                         sx={{
//                             position: 'sticky',
//                             top: 0,
//                             zIndex: 1400,
//                             background: '#061536',
//                             padding: '20px',
//                         }}
//                     >
//                         <Box
//                             sx={{
//                                 color: 'primary',
//                                 alignItems: 'center',
//                             }}
//                         >
//                             <img
//                                 style={{
//                                     width: '10rem',
//                                     height: '2rem',
//                                     alignItems: 'center',
//                                     objectFit: 'cover',
//                                     marginLeft: '-8px',
//                                     marginRight: '8px',
//                                     imageRendering: 'crisp-edges',
//                                 }}
//                                 src={logo}
//                                 alt=""
//                             />
//                         </Box>
//                         <Box
//                             sx={{
//                                 color: 'white',
//                                 fontWeight: 'bold',
//                                 fontSize: '22px',
//                             }}
//                             onClick={() => setIsSidebarMobileOpen(false)}
//                         >
//                             <AiOutlineClose />
//                         </Box>
//                     </Box>
//                     <Link to={`${PATHS.DASHBOARD.USER}`} onClick={() => setIsSidebarMobileOpen(false)}>
//                         <Box
//                             marginTop={'0'}
//                             display="flex"
//                             justifyContent="space-between"
//                             alignItems="center"
//                             gap="20px"
//                             paddingLeft={'12px'}
//                             paddingRight={'0px'}
//                         >
//                             <Box display={'flex'} alignItems={'center'} gap={'10px'}>
//                                 {user.avatar ? (
//                                     <Avatar
//                                         src={user.avatar}
//                                         sx={{
//                                             height: 40,
//                                             width: 40,
//                                         }}
//                                     />
//                                 ) : (
//                                     <DefaultAvatar sx={{ width: 40, height: 40 }} />
//                                 )}
//                                 <Typography
//                                     component={'span'}
//                                     sx={{
//                                         fontSize: '13px',
//                                         fontWeight: '700',
//                                         color: 'primary.main',
//                                         display: 'inline',
//                                         wordBreak: 'break-all',
//                                     }}
//                                 >
//                                     {user?.username}
//                                 </Typography>
//                             </Box>
//                             <Box sx={{ fontSize: '20px', color: 'white', marginRight: '20px' }}>
//                                 <FaArrowRightToBracket />
//                             </Box>
//                         </Box>
//                     </Link>

//                     <Accordion
//                         expanded={expandedAccordion === 'upcoming'}
//                         onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'upcoming' : false)}
//                         sx={{
//                             backgroundColor: 'transparent',
//                             marginTop: '20px',
//                             px: '12px',
//                             boxShadow: 'none !important',
//                             borderLeft: isAccordionActive([PATHS.DASHBOARD.UPCOMING.ROOT], location.pathname)
//                                 ? '4px solid #E4933D'
//                                 : 'none',
//                         }}
//                     >
//                         <AccordionSummary
//                             expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
//                             sx={{
//                                 height: isMobile ? '60px' : 'unset',
//                                 padding: 0,
//                                 '& .MuiAccordionSummary-content': {
//                                     margin: 0,
//                                 },
//                             }}
//                         >
//                             {/* Make only the Typography (or its wrapper Box) clickable */}
//                             <Link
//                                 to="/dashboard/upcoming"
//                                 onClick={() => setIsSidebarMobileOpen(false)}
//                                 style={{
//                                     textDecoration: 'none',
//                                     color: 'inherit',
//                                     width: '100%',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                 }}
//                             >
//                                 <Typography
//                                     sx={{
//                                         color: 'white',
//                                         width: '100%',
//                                         paddingLeft: '8px',
//                                         fontSize: '16px',
//                                         fontWeight: '400',
//                                     }}
//                                 >
//                                     Upcoming Sales
//                                 </Typography>
//                             </Link>
//                         </AccordionSummary>

//                         <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                             <Link to="/dashboard/upcoming/watchlist" onClick={() => setIsSidebarMobileOpen(false)}>
//                                 <Button
//                                     fullWidth
//                                     sx={{ justifyContent: 'flex-start', color: 'white', paddingLeft: '20px' }}
//                                 >
//                                     Watch List
//                                 </Button>
//                             </Link>
//                             <Link to="/dashboard/upcoming/buying_list" onClick={() => setIsSidebarMobileOpen(false)}>
//                                 <Button
//                                     fullWidth
//                                     sx={{ justifyContent: 'flex-start', color: 'white', paddingLeft: '20px' }}
//                                 >
//                                     My Buying List
//                                 </Button>
//                             </Link>
//                         </AccordionDetails>
//                     </Accordion>

//                     <Accordion
//                         expanded={expandedAccordion === 'event_analytics'}
//                         onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'event_analytics' : false)}
//                         sx={{
//                             backgroundColor: 'transparent',
//                             paddingLeft: '12px',
//                             paddingRight: '12px',
//                             boxShadow: 'none !important',
//                             borderLeft: isAccordionActive([PATHS.DASHBOARD.EVENT_ANALYTICS], location.pathname)
//                                 ? '4px solid #E4933D'
//                                 : 'none',
//                         }}
//                     >
//                         <AccordionSummary
//                             expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
//                             sx={{
//                                 height: isMobile ? '60px' : 'unset',
//                                 px: 0,
//                                 py: '10px',
//                             }}
//                         >
//                             <Typography sx={{ width: '100%' }}>
//                                 <Link
//                                     to="/dashboard/event_analytics"
//                                     onClick={() => setIsSidebarMobileOpen(false)}
//                                     style={{ textDecoration: 'none' }}
//                                 >
//                                     <Button
//                                         fullWidth
//                                         sx={{
//                                             justifyContent: 'flex-start',
//                                             color: 'white',
//                                             textTransform: 'none',
//                                             paddingLeft: '8px',
//                                             fontSize: '16px',
//                                             fontWeight: '400',
//                                         }}
//                                     >
//                                         Event Analytics
//                                     </Button>
//                                 </Link>
//                             </Typography>
//                         </AccordionSummary>

//                         {/* Optional: Add content or leave blank just to enable toggle */}
//                         <AccordionDetails sx={{ padding: 0 }} />
//                     </Accordion>

//                     <Accordion
//                         expanded={expandedAccordion === 'metric'}
//                         onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'metric' : false)}
//                         sx={{
//                             backgroundColor: 'transparent',
//                             paddingLeft: '12px',
//                             paddingRight: '12px',
//                             boxShadow: 'none !important',
//                             borderLeft: isAccordionActive([PATHS.DASHBOARD.METRIC.ROOT], location.pathname)
//                                 ? '4px solid #E4933D'
//                                 : 'none',
//                         }}
//                     >
//                         <AccordionSummary
//                             expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
//                             sx={{
//                                 height: isMobile ? '60px' : 'unset',
//                                 px: 0,
//                                 py: '10px',
//                             }}
//                         >
//                             <Typography sx={{ width: '100%' }}>
//                                 <Link
//                                     to="/dashboard/metric"
//                                     onClick={() => setIsSidebarMobileOpen(false)}
//                                     style={{ textDecoration: 'none' }}
//                                 >
//                                     <Button
//                                         fullWidth
//                                         sx={{
//                                             justifyContent: 'flex-start',
//                                             color: 'white',
//                                             textTransform: 'none',
//                                             paddingLeft: '8px',
//                                             fontSize: '16px',
//                                             fontWeight: '400',
//                                         }}
//                                     >
//                                         Artist Metric
//                                     </Button>
//                                 </Link>
//                             </Typography>
//                         </AccordionSummary>

//                         {/* Optional: Add content or leave blank just to enable toggle */}
//                         <AccordionDetails sx={{ padding: 0 }} />
//                     </Accordion>

//                     <Accordion
//                         expanded={expandedAccordion === 'academy'}
//                         onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'academy' : false)}
//                         sx={{
//                             backgroundColor: 'transparent',
//                             paddingLeft: '12px',
//                             paddingRight: '12px',
//                             boxShadow: 'none !important',
//                             borderLeft: isAccordionActive([PATHS.DASHBOARD.ACADEMY], location.pathname)
//                                 ? '4px solid #E4933D'
//                                 : 'none',
//                         }}
//                     >
//                         <AccordionSummary
//                             expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
//                             sx={{
//                                 height: isMobile ? '60px' : 'unset',
//                                 px: 0,
//                                 py: '10px',
//                             }}
//                         >
//                             <Typography sx={{ width: '100%' }}>
//                                 <Link
//                                     to="/dashboard/academy"
//                                     onClick={() => setIsSidebarMobileOpen(false)}
//                                     style={{ textDecoration: 'none' }}
//                                 >
//                                     <Button
//                                         fullWidth
//                                         sx={{
//                                             justifyContent: 'flex-start',
//                                             color: 'white',
//                                             textTransform: 'none',
//                                             paddingLeft: '8px',
//                                             fontSize: '16px',
//                                             fontWeight: '400',
//                                         }}
//                                     >
//                                         TMC Academy
//                                     </Button>
//                                 </Link>
//                             </Typography>
//                         </AccordionSummary>

//                         {/* Optional: Add content or leave blank just to enable toggle */}
//                         <AccordionDetails sx={{ padding: 0 }} />
//                     </Accordion>
//                     <Accordion
//                         expanded={expandedAccordion === 'secondary_top_selling'}
//                         onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'secondary_top_selling' : false)}
//                         sx={{
//                             backgroundColor: 'transparent',
//                             paddingLeft: '10px',
//                             paddingRight: '10px',
//                             boxShadow: 'none !important',
//                             borderLeft: isAccordionActive([PATHS.DASHBOARD.SECONDARY_TOP_SELLING], location.pathname)
//                                 ? '4px solid #E4933D'
//                                 : 'none',
//                         }}
//                     >
//                         <AccordionSummary
//                             expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
//                             sx={{
//                                 height: isMobile ? '60px' : 'unset',
//                                 px: 0,
//                                 py: '10px',
//                             }}
//                         >
//                             <Typography sx={{ width: '100%' }}>
//                                 <Link
//                                     to="/dashboard/secondary-top-selling"
//                                     onClick={() => setIsSidebarMobileOpen(false)}
//                                     style={{ textDecoration: 'none' }}
//                                 >
//                                     <Button
//                                         fullWidth
//                                         sx={{
//                                             justifyContent: 'flex-start',
//                                             color: 'white',
//                                             textTransform: 'none',
//                                             paddingLeft: '12px',
//                                             fontSize: '16px',
//                                             fontWeight: '400',
//                                         }}
//                                     >
//                                         SalesTIQ
//                                     </Button>
//                                 </Link>
//                             </Typography>
//                         </AccordionSummary>

//                         {/* Optional: Add content or leave blank just to enable toggle */}
//                         <AccordionDetails sx={{ padding: 0 }} />
//                     </Accordion>
//                 </>
//             )}

//             <Scrollbar>
//                 <Box
//                     sx={{
//                         height: isMobile ? '100%' : '82vh',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         justifyContent: isMobile ? 'flex-start' : 'space-between',
//                         px: collapsed && !isMobile ? 1.5 : 2,
//                         // gap: isMobile ? '2px' : isEventAnalyticsPage ? '220px' : '420px',

//                         py: 2,
//                     }}
//                 >
//                     {sections?.map((section, index) => (
//                         <React.Fragment key={index}>
//                             <NavSection
//                                 pathname={location.pathname + location.search}
//                                 collapsed={collapsed}
//                                 setCollapsed={setCollapsed}
//                                 onMobileClose={onMobileClose} // Add this
//                                 isMobile={isMobile}
//                                 {...section}
//                             />
//                         </React.Fragment>
//                     ))}
//                 </Box>
//             </Scrollbar>

//             {!isMobile && (
//                 <>
//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0px', paddingBottom: '25px' }}>
//                         <Box
//                             sx={{
//                                 color: 'white',
//                                 fontSize: '30px',
//                                 display: 'flex',
//                                 justifyContent: 'center',
//                                 alignItems: 'center',
//                                 fontWeight: 'bold',
//                                 mb: '7px',
//                                 background: '#0C2459',
//                                 px: '6px',
//                                 py: '2px',
//                                 mx: collapsed ? '' : 'auto',
//                                 cursor: 'pointer', // Add cursor pointer to indicate it's clickable
//                                 '&:hover': {
//                                     color: '#E4933D', // Change color on hover for better UX
//                                 },
//                             }}
//                             onClick={() => setCollapsed(!collapsed)} // Toggle the collapsed state
//                         >
//                             <RiArrowRightDoubleFill
//                                 style={{
//                                     transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
//                                     transition: 'transform 0.3s ease',

//                                     paddingTop: '2px',
//                                     paddingBottom: '2px',
//                                     margin: 'auto',
//                                     paddingRight: '4px',
//                                     paddingLeft: '2px',
//                                 }}
//                             />
//                         </Box>
//                         <Box
//                             component={RouterLink}
//                             to={`${PATHS.DASHBOARD.USER}`}
//                             sx={{
//                                 display: 'flex',
//                                 px: collapsed ? '8px' : '16px',
//                                 alignItems: 'center',
//                                 height: '64px',
//                                 gap: '1rem',
//                                 paddingBottom: '10px',
//                                 paddingLeft: '20px',
//                                 textDecoration: 'none',
//                                 borderTop: '1px solid #475467',
//                                 '&:hover': { bgcolor: '#0D2459' },
//                             }}
//                         >
//                             {user.avatar ? (
//                                 <Avatar
//                                     src={user.avatar}
//                                     sx={{
//                                         height: 40,
//                                         width: 40,
//                                     }}
//                                 />
//                             ) : (
//                                 <DefaultAvatar sx={{ width: 40, height: 40 }} />
//                             )}
//                             {!collapsed && (
//                                 <Typography
//                                     sx={{
//                                         fontSize: '13px',
//                                         fontWeight: '700',
//                                         color: 'primary.main',
//                                         wordBreak: 'break-all',
//                                     }}
//                                 >
//                                     {user?.username}
//                                 </Typography>
//                             )}
//                         </Box>
//                     </Box>
//                 </>
//             )}
//         </Box>
//     )

//     return (
//         <Drawer
//             anchor="left"
//             open={isMobile ? isSidebarMobileOpen : true}
//             onClose={onMobileClose}
//             variant={isMobile ? 'temporary' : 'permanent'}
//             ModalProps={{ keepMounted: true }}
//             PaperProps={{
//                 sx: {
//                     borderRight: 'unset',
//                     overflow: 'hidden',
//                     borderTopRightRadius: '50px',
//                     borderBottomRightRadius: '50px',
//                     ...(isMobile
//                         ? {
//                               top: 0,
//                               height: '100%',
//                               zIndex: (theme) => theme.zIndex.drawer + 10,
//                               borderTopRightRadius: '30px',
//                               width: '330px',
//                           }
//                         : {
//                               top: !isTopSelling ? '64px' : '0px',
//                               height: `calc(100% - ${!isTopSelling ? '64px' : '0px'})`,
//                               zIndex: (theme) => theme.zIndex.drawer,
//                           }),
//                 },
//             }}
//         >
//             {content}
//         </Drawer>
//     )
// }

// DashboardSidebar.propTypes = {
//     onMobileClose: PropTypes.func,
//     openMobile: PropTypes.bool,
//     collapsed: PropTypes.bool,
//     isMobile: PropTypes.bool,
//     setCollapsed: PropTypes.func,
// }

// export default DashboardSidebar

import ConstructionIcon from '@mui/icons-material/Construction'
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined'
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined'
import ListAltIcon from '@mui/icons-material/ListAlt'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import HistoryIcon from '@mui/icons-material/History'
import HomeIcon from '@mui/icons-material/Home'
import { RiArrowRightDoubleFill } from 'react-icons/ri'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Avatar, Box, Button, Drawer, Icon, Stack, Typography, IconButton } from '@mui/material'
import { useTheme, Theme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import PropTypes from 'prop-types'
import type { FC, ReactNode } from 'react'
import React, { useEffect, useState } from 'react'
import { Img } from 'react-image'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import PATHS from 'src/common/constants/paths'
import useAuth from 'src/hooks/useAuth'
import DefaultAvatar from 'src/icons/DefaultAvatar'
import NavSection from '../../general/NavSection'
import Scrollbar from '../../general/Scrollbar'
import CloseIcon from '@mui/icons-material/Close'
import logo from 'src/icons/logo-dark.svg'
import { FaArrowRightToBracket } from 'react-icons/fa6'
import { AiOutlineClose } from 'react-icons/ai'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import { Link } from 'react-router-dom'

import DashboardNavbar from 'src/components/dashboard/layout/DashboardNavbar'

interface DashboardSidebarProps {
    onMobileClose: () => void
    openMobile: boolean
    collapsed: boolean
    isMobile: boolean
    isSidebarMobileOpen: boolean
    setIsSidebarMobileOpen: React.Dispatch<React.SetStateAction<boolean>>
    setCollapsed: React.Dispatch<React.SetStateAction<boolean>>
}

interface NavItem {
    icon: ReactNode
    title: string
    path: string
    disabled?: boolean
    hover?: string
    tooltip?: string
    accessCondition?: boolean
    children?: { title: string; hover?: string; path: string }[]
}

interface dashboardSections {
    title: string
    items: NavItem[]
}

const activeButton = (path: string, include: string[]) => {
    if (
        include.filter((elem) => {
            return path.includes(elem)
        }).length > 0
    ) {
        return { borderBottom: '2px solid #E4933D', backgroundImage: 'linear-gradient(to bottom, #091E50, #132E69)' }
    } else return { bgcolor: 'transparent', color: 'primary' }
}

const buttonNavBarStyle = {
    py: '1.21rem',
    width: { lg: '200px' },
    '&:hover': { backgroundImage: 'linear-gradient(to bottom, #091E50, #132E69)' },
}

const defaultSections: dashboardSections[] = [
    {
        title: '',
        items: [
            {
                icon: (
                    <Icon sx={{ display: 'flex', alignItems: 'center' }}>
                        <img src="/static/icons/discord_white.svg" alt="Discord" />
                    </Icon>
                ),
                title: 'Community',
                path: `${PATHS.DASHBOARD.COMMUNITY}`,
            },
            {
                icon: <NotificationsNoneIcon />,
                title: 'Alerts',
                path: `${PATHS.DASHBOARD.ALERTS}`,
            },
            {
                icon: <ConstructionIcon />,
                title: 'Extension',
                path: `${PATHS.DASHBOARD.EXTENSION}`,
            },
            {
                icon: <HelpOutlineIcon />,
                title: 'Support',
                path: `${PATHS.DASHBOARD.SUPPORT}`,
            },
        ],
    },
]

const sectionsTopSelling: dashboardSections[] = [
    {
        title: '',
        items: [
            {
                icon: <HomeIcon />,
                title: 'Home',
                path: `${PATHS.DASHBOARD.UPCOMING.ROOT}`,
            },
        ],
    },
]

const sectionsAnalytics = (user: any): dashboardSections[] => [
    {
        title: '',
        items: [
            {
                icon: <EventAvailableOutlinedIcon />,
                title: 'My Primary Favorites',
                path: `${PATHS.DASHBOARD.PRIMARY_FAVORITES}`,
                hover: 'Save and track your favorite events on the primary market. You can also perform and view actions such as drop checkers and low inventory alerts for your favorites.',
                tooltip: 'My Primary Favorites',
            },
            {
                icon: <EventOutlinedIcon />,
                title: 'My Secondary Favorites',
                path: `${PATHS.DASHBOARD.SECONDARY_FAVORITES}`,
                hover: 'Save and track your favorite events on the secondary market. You can also perform and view actions such as price drop alerts for your favorites.',
                tooltip: 'My Secondary Favorites',
            },
            {
                icon: <QueryStatsIcon />,
                title: 'Primary Top Movers',
                hover: 'View top moving events by the most tickets sold or highest percentage change on the primary market.',
                path: `${PATHS.DASHBOARD.PRIMARY_TOP_MOVERS}`,
                tooltip: 'Primary Top Movers',
                accessCondition: user.payment_plans?.[0]?.hasAccessToTopMovers,
            },
            {
                icon: <HistoryIcon />,
                title: 'Custom Requests History',
                path: `${PATHS.DASHBOARD.CUSTOM_REQUESTS_HISTORY}`,
                hover: 'View the status and details of your data refresh requests for StubHub events.',
                tooltip: 'Custom Requests History',
            },
        ],
    },
]

const sectionsAdmin: dashboardSections[] = [
    {
        title: '',
        items: [
            {
                icon: <ListAltIcon />,
                title: 'General',
                path: `${PATHS.DASHBOARD.ADMIN.ROOT}`,
                children: [
                    {
                        title: 'Subscription Management',
                        path: `${PATHS.DASHBOARD.ADMIN.SUBSCRIPTION_MANAGEMENT}`,
                        hover: 'Manage users subscription',
                    },
                    {
                        title: 'Tier Management',
                        path: `${PATHS.DASHBOARD.ADMIN.TIER_MANAGEMENT}`,
                        hover: 'Manage tiers',
                    },
                    { title: 'Venue Match', path: `${PATHS.DASHBOARD.ADMIN.VENUE_MATCH}`, hover: 'Venue matching' },
                    { title: 'Event Match', path: `${PATHS.DASHBOARD.ADMIN.EVENT_MATCH}`, hover: 'Event matching' },
                    {
                        title: 'Venue Mismatch',
                        path: `${PATHS.DASHBOARD.ADMIN.VENUE_MISMATCH}`,
                        hover: 'Venue mismatching',
                    },
                    { title: 'Seat Groups', path: `${PATHS.DASHBOARD.ADMIN.SEAT_GROUPS}`, hover: 'Seat groups' },
                    {
                        title: 'Add Venue Urls',
                        path: `${PATHS.DASHBOARD.ADMIN.VENUE_URLS}`,
                        hover: 'Add/remove venue urls',
                    },
                    {
                        title: 'Add Blacklist Words',
                        path: `${PATHS.DASHBOARD.ADMIN.BLACKLIST}`,
                        hover: 'Add/remove black list words',
                    },
                    {
                        title: 'Scrape Venue',
                        path: `${PATHS.DASHBOARD.ADMIN.SCRAPE_VENUE}`,
                        hover: 'Scrape a venue using venue id',
                    },
                    {
                        title: 'Hot Sections',
                        path: `${PATHS.DASHBOARD.ADMIN.HOT_SECTIONS}`,
                        hover: 'Find out hot sections',
                    },
                    { title: 'SH Daily', path: `${PATHS.DASHBOARD.ADMIN.SH_DAILY}`, hover: 'SH Daily' },
                    { title: 'TM Daily', path: `${PATHS.DASHBOARD.ADMIN.TM_DAILY}`, hover: 'TM Daily' },
                    {
                        title: 'Stubhub Helper',
                        path: `${PATHS.DASHBOARD.ADMIN.STUBHUB_HELPER}`,
                        hover: 'Stubhub Helper',
                    },
                    {
                        title: 'Client API Admin',
                        path: `${PATHS.DASHBOARD.ADMIN.CLIENT_API_ADMIN}`,
                        hover: 'Manage Client API Users and Settings',
                    },
                    {
                        title: 'Rate Limit',
                        path: `${PATHS.DASHBOARD.ADMIN.RATE_LIMIT}`,
                        hover: 'Manage Rate Limit',
                    },
                ],
            },
        ],
    },
]

const isAccordionActive = (parentPaths: string[], pathname: string) => {
    return parentPaths.some((parentPath) => pathname === parentPath || pathname.startsWith(parentPath + '/'))
}

const DashboardSidebar: FC<DashboardSidebarProps> = (props) => {
    const {
        onMobileClose,
        openMobile,
        collapsed,
        setIsSidebarMobileOpen,
        setCollapsed,
        isSidebarMobileOpen,
        isMobile,
    } = props
    const { user } = useAuth()
    const [sections, setSections] = useState<dashboardSections[]>(defaultSections)
    const location = useLocation()

    const [expandedAccordion, setExpandedAccordion] = useState<string | false>(false)
    const [isExpended, setisExpended] = useState(false)
    const [isSecondaryTopSellingMinimal, setIsSecondaryTopSellingMinimal] = useState(false)

    const sectionsUpcoming: dashboardSections[] = [
        {
            title: '',
            items: [
                {
                    icon: <ListAltIcon />,
                    title: 'General',
                    path: `${PATHS.DASHBOARD.ROOT}`,
                    ...(!isMobile && {
                        children: [
                            { title: 'Watch List', path: `${PATHS.DASHBOARD.UPCOMING.WATCHLIST}` },
                            { title: 'My Buying List', path: `${PATHS.DASHBOARD.UPCOMING.BUYING_LIST}` },
                        ],
                    }),
                },
            ],
        },
    ]

    const isTopSelling = location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`)
    const isSecondaryTopSellingPage = location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`)

    const handleToggle = () => {
        setisExpended((prev) => !prev)
    }

    const isHeaderNavbarHidden = [PATHS.DASHBOARD.SECONDARY_TOP_SELLING, PATHS.DASHBOARD.HISTORICAL_DATA].some((path) =>
        location.pathname.includes(path)
    )

    useEffect(() => {
        if (isSecondaryTopSellingPage) {
            // Only show the home button for secondary-top-selling page
            setSections(sectionsTopSelling)
            setIsSecondaryTopSellingMinimal(true)
        } else if (location.pathname.includes(`${PATHS.DASHBOARD.UPCOMING.ROOT}`)) {
            setSections([...sectionsUpcoming, ...defaultSections])
            setIsSecondaryTopSellingMinimal(false)
        } else if (
            [
                PATHS.DASHBOARD.EVENT_ANALYTICS,
                PATHS.DASHBOARD.SECONDARY_ANALYTICS.split(':')[0],
                PATHS.DASHBOARD.PRIMARY_ANALYTICS.split(':')[0],
                PATHS.DASHBOARD.PRIMARY_FAVORITES,
                PATHS.DASHBOARD.SECONDARY_FAVORITES,
                PATHS.DASHBOARD.USER,
                PATHS.DASHBOARD.METRIC.ROOT,
                PATHS.DASHBOARD.PRIMARY_TOP_MOVERS,
            ].some((path) => location.pathname.includes(path))
        ) {
            const modifiedSections = sectionsAnalytics(user)?.map((section) => ({
                ...section,
                items: section.items?.map((item) => ({
                    ...item,
                    disabled: typeof item.accessCondition === 'boolean' ? !item.accessCondition : false,
                })),
            }))
            setSections([...modifiedSections, ...defaultSections])
            setIsSecondaryTopSellingMinimal(false)
        } else if (location.pathname.includes(`${PATHS.DASHBOARD.ADMIN.ROOT}`)) {
            setSections([...sectionsAdmin, ...defaultSections])
            setIsSecondaryTopSellingMinimal(false)
        } else {
            setSections([...sectionsUpcoming, ...defaultSections])
            setIsSecondaryTopSellingMinimal(false)
        }
    }, [location.pathname, user, openMobile, onMobileClose, isSecondaryTopSellingPage])

    const isEventAnalyticsPage =
        window.location.pathname === '/dashboard/event_analytics' ||
        window.location.pathname.includes('/dashboard/secondary-analytics/') ||
        window.location.pathname.includes('/dashboard/primary-analytics/')

    useEffect(() => {
        if (isSecondaryTopSellingPage) {
            // Close the regular sidebar when navigating to secondary-top-selling
            if (!isMobile) {
                setCollapsed(true) // Collapse the regular sidebar
            } else {
                setIsSidebarMobileOpen(false) // Close mobile sidebar
            }
        }
    }, [isSecondaryTopSellingPage, isMobile, setCollapsed, setIsSidebarMobileOpen])

    // Minimal sidebar content for secondary-top-selling page
    const minimalSidebarContent = (
        <Box
            sx={{
                width: isMobile ? '60%' : collapsed ? '80px' : '15%',
                height: '100vh',
                background: '#061536',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingTop: '20px',
                position: 'fixed',
                borderTopRightRadius: '20px',
                zIndex: 1300,
                borderRight: '1px solid rgba(255, 255, 255, 0.12)',
            }}
        >
            <Box
                component={RouterLink}
                to={PATHS.DASHBOARD.UPCOMING.ROOT}
                onClick={() => {
                    setIsSidebarMobileOpen(false)
                    setIsSecondaryTopSellingMinimal(false)
                }}
                sx={{ display: 'flex', alignItems: 'center', gap: '60px' }}
            >
                <img
                    src="https://app.ticketmetric.io/static/logo.svg"
                    alt="profile"
                    style={{
                        width: collapsed ? '90%' : '60%',

                        height: collapsed ? '70%' : '60%',
                        objectFit: 'cover',
                    }}
                />

                {!collapsed && (
                    <>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', paddingBottom: '62px' }}>
                            <Typography variant="caption" sx={{ color: 'white', textAlign: 'center' }}>
                                Home
                            </Typography>
                            <Box sx={{ color: 'white !important', fontSize: '10px' }}>
                                <InfoOutlinedIcon fontSize="small" />
                            </Box>
                        </Box>
                    </>
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0px', paddingBottom: '25px' }}>
                {!isMobile && (
                    <Box
                        sx={{
                            color: 'white',
                            fontSize: '30px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontWeight: 'bold',
                            mb: '7px',
                            background: '#0C2459',
                            px: '6px',
                            py: '2px',
                            mx: collapsed ? '' : 'auto',
                            cursor: 'pointer',
                            '&:hover': {
                                color: '#E4933D',
                            },
                        }}
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        <RiArrowRightDoubleFill
                            style={{
                                transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                                transition: 'transform 0.3s ease',
                                paddingTop: '2px',
                                paddingBottom: '2px',
                                margin: 'auto',
                                paddingRight: '4px',
                                paddingLeft: '2px',
                            }}
                        />
                    </Box>
                )}

                <Box
                    component={RouterLink}
                    to={`${PATHS.DASHBOARD.USER}`}
                    sx={{
                        display: 'flex',
                        px: collapsed ? '8px' : '16px',
                        alignItems: 'center',
                        height: '64px',

                        gap: '1rem',
                        paddingBottom: '10px',
                        paddingLeft: '20px',
                        textDecoration: 'none',
                        borderTop: '1px solid #475467',
                        borderWidth: '100%',
                        '&:hover': { bgcolor: '#0D2459' },
                    }}
                >
                    {user.avatar ? (
                        <Avatar
                            src={user.avatar}
                            sx={{
                                height: 40,
                                width: 40,
                            }}
                        />
                    ) : (
                        <DefaultAvatar sx={{ width: 40, height: 40 }} />
                    )}
                    {!collapsed && (
                        <Typography
                            sx={{
                                fontSize: '13px',
                                fontWeight: '700',
                                color: 'primary.main',
                                wordBreak: 'break-all',
                            }}
                        >
                            {user?.username}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box>
    )

    const content = (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`) ? '100vh' : '100vh',
                maxHeight: location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`) ? '100vh' : '94vh',
                overflow: 'auto',
                zIndex: 1300,
                justifyContent: 'space-between',
                background: '#061536',
                paddingBottom: '30px',
                width: isMobile ? '330px' : collapsed && !isMobile ? '80px' : '250px',
                transition: 'width 0.3s ease',
                position: 'fixed',
                borderTopRightRadius: location.pathname.includes(`${PATHS.DASHBOARD.SECONDARY_TOP_SELLING}`)
                    ? '20px'
                    : '0px',
            }}
        >
            {isMobile && (
                <>
                    <Box
                        display={'flex'}
                        justifyContent={'space-between'}
                        padding={'20px'}
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1400,
                            background: '#061536',
                            padding: '20px',
                        }}
                    >
                        <Box
                            sx={{
                                color: 'primary',
                                alignItems: 'center',
                            }}
                        >
                            <img
                                style={{
                                    width: '10rem',
                                    height: '2rem',
                                    alignItems: 'center',
                                    objectFit: 'cover',
                                    marginLeft: '-8px',
                                    marginRight: '8px',
                                    imageRendering: 'crisp-edges',
                                }}
                                src={logo}
                                alt=""
                            />
                        </Box>
                        <Box
                            sx={{
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '22px',
                            }}
                            onClick={() => setIsSidebarMobileOpen(false)}
                        >
                            <AiOutlineClose />
                        </Box>
                    </Box>
                    <Link to={`${PATHS.DASHBOARD.USER}`} onClick={() => setIsSidebarMobileOpen(false)}>
                        <Box
                            marginTop={'0'}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            gap="20px"
                            paddingLeft={'12px'}
                            paddingRight={'0px'}
                        >
                            <Box display={'flex'} alignItems={'center'} gap={'10px'}>
                                {user.avatar ? (
                                    <Avatar
                                        src={user.avatar}
                                        sx={{
                                            height: 40,
                                            width: 40,
                                        }}
                                    />
                                ) : (
                                    <DefaultAvatar sx={{ width: 40, height: 40 }} />
                                )}
                                <Typography
                                    component={'span'}
                                    sx={{
                                        fontSize: '13px',
                                        fontWeight: '700',
                                        color: 'primary.main',
                                        display: 'inline',
                                        wordBreak: 'break-all',
                                    }}
                                >
                                    {user?.username}
                                </Typography>
                            </Box>
                            <Box sx={{ fontSize: '20px', color: 'white', marginRight: '20px' }}>
                                <FaArrowRightToBracket />
                            </Box>
                        </Box>
                    </Link>

                    <Accordion
                        expanded={expandedAccordion === 'upcoming'}
                        onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'upcoming' : false)}
                        sx={{
                            backgroundColor: 'transparent',
                            marginTop: '20px',
                            px: '12px',
                            boxShadow: 'none !important',
                            borderLeft: isAccordionActive([PATHS.DASHBOARD.UPCOMING.ROOT], location.pathname)
                                ? '4px solid #E4933D'
                                : 'none',
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                            sx={{
                                height: isMobile ? '60px' : 'unset',
                                padding: 0,
                                '& .MuiAccordionSummary-content': {
                                    margin: 0,
                                },
                            }}
                        >
                            <Link
                                to="/dashboard/upcoming"
                                onClick={() => setIsSidebarMobileOpen(false)}
                                style={{
                                    textDecoration: 'none',
                                    color: 'inherit',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: 'white',
                                        width: '100%',
                                        paddingLeft: '8px',
                                        fontSize: '16px',
                                        fontWeight: '400',
                                    }}
                                >
                                    Upcoming Sales
                                </Typography>
                            </Link>
                        </AccordionSummary>

                        <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link to="/dashboard/upcoming/watchlist" onClick={() => setIsSidebarMobileOpen(false)}>
                                <Button
                                    fullWidth
                                    sx={{ justifyContent: 'flex-start', color: 'white', paddingLeft: '20px' }}
                                >
                                    Watch List
                                </Button>
                            </Link>
                            <Link to="/dashboard/upcoming/buying_list" onClick={() => setIsSidebarMobileOpen(false)}>
                                <Button
                                    fullWidth
                                    sx={{ justifyContent: 'flex-start', color: 'white', paddingLeft: '20px' }}
                                >
                                    My Buying List
                                </Button>
                            </Link>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion
                        expanded={expandedAccordion === 'event_analytics'}
                        onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'event_analytics' : false)}
                        sx={{
                            backgroundColor: 'transparent',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            boxShadow: 'none !important',
                            borderLeft: isAccordionActive([PATHS.DASHBOARD.EVENT_ANALYTICS], location.pathname)
                                ? '4px solid #E4933D'
                                : 'none',
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                            sx={{
                                height: isMobile ? '60px' : 'unset',
                                px: 0,
                                py: '10px',
                            }}
                        >
                            <Typography sx={{ width: '100%' }}>
                                <Link
                                    to="/dashboard/event_analytics"
                                    onClick={() => setIsSidebarMobileOpen(false)}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Button
                                        fullWidth
                                        sx={{
                                            justifyContent: 'flex-start',
                                            color: 'white',
                                            textTransform: 'none',
                                            paddingLeft: '8px',
                                            fontSize: '16px',
                                            fontWeight: '400',
                                        }}
                                    >
                                        Event Analytics
                                    </Button>
                                </Link>
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails sx={{ padding: 0 }} />
                    </Accordion>

                    <Accordion
                        expanded={expandedAccordion === 'metric'}
                        onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'metric' : false)}
                        sx={{
                            backgroundColor: 'transparent',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            boxShadow: 'none !important',
                            borderLeft: isAccordionActive([PATHS.DASHBOARD.METRIC.ROOT], location.pathname)
                                ? '4px solid #E4933D'
                                : 'none',
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                            sx={{
                                height: isMobile ? '60px' : 'unset',
                                px: 0,
                                py: '10px',
                            }}
                        >
                            <Typography sx={{ width: '100%' }}>
                                <Link
                                    to="/dashboard/metric"
                                    onClick={() => setIsSidebarMobileOpen(false)}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Button
                                        fullWidth
                                        sx={{
                                            justifyContent: 'flex-start',
                                            color: 'white',
                                            textTransform: 'none',
                                            paddingLeft: '8px',
                                            fontSize: '16px',
                                            fontWeight: '400',
                                        }}
                                    >
                                        Artist Metric
                                    </Button>
                                </Link>
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails sx={{ padding: 0 }} />
                    </Accordion>

                    <Accordion
                        expanded={expandedAccordion === 'academy'}
                        onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'academy' : false)}
                        sx={{
                            backgroundColor: 'transparent',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            boxShadow: 'none !important',
                            borderLeft: isAccordionActive([PATHS.DASHBOARD.ACADEMY], location.pathname)
                                ? '4px solid #E4933D'
                                : 'none',
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                            sx={{
                                height: isMobile ? '60px' : 'unset',
                                px: 0,
                                py: '10px',
                            }}
                        >
                            <Typography sx={{ width: '100%' }}>
                                <Link
                                    to="/dashboard/academy"
                                    onClick={() => setIsSidebarMobileOpen(false)}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Button
                                        fullWidth
                                        sx={{
                                            justifyContent: 'flex-start',
                                            color: 'white',
                                            textTransform: 'none',
                                            paddingLeft: '8px',
                                            fontSize: '16px',
                                            fontWeight: '400',
                                        }}
                                    >
                                        TMC Academy
                                    </Button>
                                </Link>
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails sx={{ padding: 0 }} />
                    </Accordion>
                    <Accordion
                        expanded={expandedAccordion === 'secondary_top_selling'}
                        onChange={(_, isExpanded) => setExpandedAccordion(isExpanded ? 'secondary_top_selling' : false)}
                        sx={{
                            backgroundColor: 'transparent',
                            paddingLeft: '10px',
                            paddingRight: '10px',
                            boxShadow: 'none !important',
                            borderLeft: isAccordionActive([PATHS.DASHBOARD.SECONDARY_TOP_SELLING], location.pathname)
                                ? '4px solid #E4933D'
                                : 'none',
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                            sx={{
                                height: isMobile ? '60px' : 'unset',
                                px: 0,
                                py: '10px',
                            }}
                        >
                            <Typography sx={{ width: '100%' }}>
                                <Link
                                    to="/dashboard/secondary-top-selling"
                                    onClick={() => setIsSidebarMobileOpen(false)}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <Button
                                        fullWidth
                                        sx={{
                                            justifyContent: 'flex-start',
                                            color: 'white',
                                            textTransform: 'none',
                                            paddingLeft: '12px',
                                            fontSize: '16px',
                                            fontWeight: '400',
                                        }}
                                    >
                                        SalesTIQ
                                    </Button>
                                </Link>
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails sx={{ padding: 0 }} />
                    </Accordion>
                </>
            )}

            <Scrollbar>
                <Box
                    sx={{
                        height: isMobile ? '100%' : '82vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: isMobile ? 'flex-start' : 'space-between',
                        px: collapsed && !isMobile ? 1.5 : 2,
                        py: 2,
                    }}
                >
                    {sections?.map((section, index) => (
                        <React.Fragment key={index}>
                            <NavSection
                                pathname={location.pathname + location.search}
                                collapsed={collapsed}
                                setCollapsed={setCollapsed}
                                onMobileClose={onMobileClose}
                                isMobile={isMobile}
                                {...section}
                            />
                        </React.Fragment>
                    ))}
                </Box>
            </Scrollbar>

            {!isMobile && (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0px', paddingBottom: '25px' }}>
                        <Box
                            sx={{
                                color: 'white',
                                fontSize: '30px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontWeight: 'bold',
                                mb: '7px',
                                background: '#0C2459',
                                px: '6px',
                                py: '2px',
                                mx: collapsed ? '' : 'auto',
                                cursor: 'pointer',
                                '&:hover': {
                                    color: '#E4933D',
                                },
                            }}
                            onClick={() => setCollapsed(!collapsed)}
                        >
                            <RiArrowRightDoubleFill
                                style={{
                                    transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                                    transition: 'transform 0.3s ease',
                                    paddingTop: '2px',
                                    paddingBottom: '2px',
                                    margin: 'auto',
                                    paddingRight: '4px',
                                    paddingLeft: '2px',
                                }}
                            />
                        </Box>
                        <Box
                            component={RouterLink}
                            to={`${PATHS.DASHBOARD.USER}`}
                            sx={{
                                display: 'flex',
                                px: collapsed ? '8px' : '16px',
                                alignItems: 'center',
                                height: '64px',
                                gap: '1rem',
                                paddingBottom: '10px',
                                paddingLeft: '20px',
                                textDecoration: 'none',
                                borderTop: '1px solid #475467',
                                '&:hover': { bgcolor: '#0D2459' },
                            }}
                        >
                            {user.avatar ? (
                                <Avatar
                                    src={user.avatar}
                                    sx={{
                                        height: 40,
                                        width: 40,
                                    }}
                                />
                            ) : (
                                <DefaultAvatar sx={{ width: 40, height: 40 }} />
                            )}
                            {!collapsed && (
                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        fontWeight: '700',
                                        color: 'primary.main',
                                        wordBreak: 'break-all',
                                    }}
                                >
                                    {user?.username}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    )

    return (
        <>
            {isSecondaryTopSellingPage && isSecondaryTopSellingMinimal ? (
                <Drawer
                    anchor="left"
                    open={isMobile ? isSidebarMobileOpen : true}
                    onClose={onMobileClose}
                    variant={isMobile ? 'temporary' : 'permanent'}
                    ModalProps={{ keepMounted: true }}
                    PaperProps={{
                        sx: {
                            borderRight: 'unset',
                            overflow: 'hidden',
                            borderTopRightRadius: '50px',
                            borderBottomRightRadius: '50px',
                            ...(isMobile
                                ? {
                                      top: 0,
                                      height: '100%',
                                      zIndex: (theme) => theme.zIndex.drawer + 10,
                                      borderTopRightRadius: '30px',
                                      width: '80px',
                                  }
                                : {
                                      top: !isTopSelling ? '64px' : '0px',
                                      height: `calc(100% - ${!isTopSelling ? '64px' : '0px'})`,
                                      zIndex: (theme) => theme.zIndex.drawer,
                                  }),
                        },
                    }}
                >
                    {minimalSidebarContent}
                </Drawer>
            ) : (
                <Drawer
                    anchor="left"
                    open={isMobile ? isSidebarMobileOpen : true}
                    onClose={onMobileClose}
                    variant={isMobile ? 'temporary' : 'permanent'}
                    ModalProps={{ keepMounted: true }}
                    PaperProps={{
                        sx: {
                            borderRight: 'unset',
                            overflow: 'hidden',
                            borderTopRightRadius: '50px',
                            borderBottomRightRadius: '50px',
                            ...(isMobile
                                ? {
                                      top: 0,
                                      height: '100%',
                                      zIndex: (theme) => theme.zIndex.drawer + 10,
                                      borderTopRightRadius: '30px',
                                      width: '330px',
                                  }
                                : {
                                      top: !isTopSelling ? '64px' : '0px',
                                      height: `calc(100% - ${!isTopSelling ? '64px' : '0px'})`,
                                      zIndex: (theme) => theme.zIndex.drawer,
                                  }),
                        },
                    }}
                >
                    {content}
                </Drawer>
            )}
        </>
    )
}

DashboardSidebar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool,
    collapsed: PropTypes.bool,
    isMobile: PropTypes.bool,
    setCollapsed: PropTypes.func,
}

export default DashboardSidebar
